import { render } from "./datosCatalogo.vue?vue&type=template&id=080e5cf8&scoped=true"
import script from "./datosCatalogo.vue?vue&type=script&lang=js"
export * from "./datosCatalogo.vue?vue&type=script&lang=js"

import "./datosCatalogo.vue?vue&type=style&index=0&id=080e5cf8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-080e5cf8"

export default script